import {
  SOUS_TYPE_AVOIR,
  SOUS_TYPE_AVOIR_SUR_ACOMPTE,
  TOTAL_RAPPROCHEMENT,
  PARTIEL_RAPPROCHEMENT,
  NO_RAPPROCHEMENT,
} from '@/configuration/facture/factureConf';
import calculArrondi from '@/services/calcul/calculArrondi';

export function getStatutRapprochement(commandeAchatRapprocher, montantARapprocher, sousType) {
  if (commandeAchatRapprocher.length === 0) return NO_RAPPROCHEMENT;
  const montantAffecter = commandeAchatRapprocher
    .map((echeance) => echeance.montantAffecter)
    .reduce((a, b) => calculArrondi(a + b));
  if (montantAffecter === montantARapprocher) {
    if ((sousType === SOUS_TYPE_AVOIR || sousType === SOUS_TYPE_AVOIR_SUR_ACOMPTE)
      && montantARapprocher < 0) return TOTAL_RAPPROCHEMENT;
    if (montantARapprocher > 0) return TOTAL_RAPPROCHEMENT;
  }
  if (montantAffecter < montantARapprocher || montantARapprocher === 0) {
    return PARTIEL_RAPPROCHEMENT;
  }
  return NO_RAPPROCHEMENT;
}

export function getColorStatusRapprochement(statutRapprochement) {
  switch (statutRapprochement) {
    case TOTAL_RAPPROCHEMENT:
      return 'round-circle-success';
    case PARTIEL_RAPPROCHEMENT:
      return 'round-circle-warning';
    case NO_RAPPROCHEMENT:
      return 'round-circle-danger';
    default:
      return 'round-circle-danger';
  }
}

export function getColorStatusRapprochementFromCommande(commandeAchatRapprocher) {
  const status = getStatutRapprochement(commandeAchatRapprocher);
  return getColorStatusRapprochement(status);
}
